import axios from '@/plugins/axios'

export function getWorkOrders(params = {}) {
  return axios.get('work_order', {
    params,
  })
}

export function getworkOrderTypes() {
  return axios.get('work_order/workOrderType')
}

export function addworkOrder(data) {
  return axios.post('work_order/addworkOrder', data)
}

export function mulOverWorkOrder(data) {
  return axios.post('work_order/mulOverWorkOrder', data)
}

export function mulAssignWorkOrder(data) {
  return axios.post('work_order/mulAssignWorkOrder', data)
}

export function getWarningByWorkOrderId(params = {}) {
  return axios.get('work_order/getWarningByWorkOrderId', {
    params,
  })
}
